import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import React from "react";
import { useTranslation } from "react-i18next";
import { i18_SIGNUP } from "../../i18nReferences";
import errorImage from "../../public/images/error.png";

/**
 * Error view for the signup process
 * Displays an error message with an error image
 * 
 * @param {Object} props
 * @param {string} props.errorText - Translation key for the error message
 */
const SignupErrorView = ({ errorText }) => {
    const { t } = useTranslation([i18_SIGNUP]);

    return (
        <Container maxWidth="md">
            <Box sx={{ mt: 4 }}>
                <img width="100%" src={errorImage} alt="error-image" />
                <Alert severity="error">{t(errorText)}</Alert>
            </Box>
        </Container>
    );
};

export default SignupErrorView;

